
import { supabase } from "@/integrations/supabase/client";
import { handleError } from "@/utils/error-handling";

/**
 * Get count of games played by anonymous users identified by IP address
 */
export const getAnonymousPlayedGamesCount = async (): Promise<number> => {
  try {
    // Use the edge function to get count of games played
    const { data, error } = await supabase.functions.invoke('track-game-play', {
      method: 'GET'
    });
    
    if (error) {
      console.error("Error getting anonymous played games count:", error);
      return 0; // Return 0 to allow users to continue playing if tracking fails
    }
    
    return data?.gameCount || 0;
  } catch (error) {
    console.error("Failed to get anonymous played games count:", error);
    // Return 0 as a fallback to ensure users can play without tracking
    return 0;
  }
};

/**
 * Increment count of games played by anonymous users identified by IP address
 * Now using a secure database function with an immutable search path
 */
export const incrementAnonymousPlayedGamesCount = async (): Promise<number> => {
  try {
    // Use the edge function to increment count of games played
    const { data, error } = await supabase.functions.invoke('track-game-play', {
      method: 'POST'
    });
    
    if (error) {
      console.error("Error incrementing anonymous played games count:", error);
      handleError(error, "Could not update game session data");
      // Instead of bubbling up the error, return a default value to allow users to continue
      return await getAnonymousPlayedGamesCount();
    }
    
    return data?.gameCount || 0;
  } catch (error) {
    console.error("Failed to increment anonymous played games count:", error);
    handleError(error, "Could not update game session data");
    // Return the current count as a fallback
    return await getAnonymousPlayedGamesCount();
  }
};
